import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import NearMeIcon from "@material-ui/icons/NearMe";
import { moveGMapsPoint } from "../GoogleMaps";
import { getGeolocation } from "../../../apis/geolocationAction";
import { userLogging } from "../../../apis/userLog";
import { Tooltip } from "@material-ui/core";
import {
  selectExclusiveFlg,
  selectExclusiveMobakuFlg,
} from "../../../features/marketAreaStatusSlice";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      backgroundColor: "#fff",
      "&:hover": {
        background: "#d9d9d9",
      },
      height: "40px",
      width: "40px",
      padding: "10px",
    },
  })
);

const MapsGeolocationButton: React.FC = (props: any) => {
  const classes = useStyles({});
  const exclusiveFlg = useSelector(selectExclusiveFlg);
  const exclusiveMobakuFlg = useSelector(selectExclusiveMobakuFlg);
  useEffect(() => {}, []);
  const handleGeolocation = () => {
    getGeolocation()
      .then((position: any) => {
        moveGMapsPoint(position.coords.latitude, position.coords.longitude);
        userLogging("OPVIEW", "OPVIEW＃現在地", "");
      })
      .catch((err) => {
        alert("現在地情報が取得できませんでした");
        userLogging(
          "OPVIEW",
          "OPVIEW＃現在地表示エラー",
          `code:${err.code},message:${err.message}`
        );
      });
  };

  return (
    <Tooltip
      title={<span style={{ fontSize: "16px" }}>{"現在位置に移動する"}</span>}
      placement="left"
      disableTouchListener
    >
      <IconButton
        className={classes.button + " map-item-shadow"}
        style={
          exclusiveFlg || exclusiveMobakuFlg ? { pointerEvents: "none" } : {}
        }
        onClick={() => handleGeolocation()}
      >
        <NearMeIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default MapsGeolocationButton;
